<template>
  <div>
    <app-spinner v-if="!is_page_loaded" />
    <app-page-container v-else>
      <h2 class="title title--mb15">Confirmed</h2>
      <template v-if="booked_reservations.length > 0">
        <AppAccSafari
            v-for="(safari, safari_index) in booked_reservations"
            :key="`booked_reservations_${safari.id}`"
            :reservation="safari"
            :order-number="safari_index + 1"
        />
        <app-cells :position="pagination_booked.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickBookedPagination"
            v-if="pagination_booked.pages > 1"
            v-model="pagination_booked.page"
            :page-count="pagination_booked.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records
            :all="pagination_booked.count"
            :count="booked_reservations.length"
            :page="pagination_booked.page"
          />
        </app-cells>
      </template>
      <app-no-results v-else text="There’s no bookings yet" />
    </app-page-container>
  </div>
</template>

<script>
import { getReservationsSafari } from '@/http'
import AppAccSafari from '@/components/AppAccSafari.vue'

export default {
  name: 'SafariReservationsListUpcoming',
  components: { AppAccSafari },
  data() {
    return {
      is_page_loaded: false,
      booked_reservations: [],
      pagination_new: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_booked: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created () {
    this.fetchBookedReservations()
  },
  methods: {
    fetchBookedReservations() {
      getReservationsSafari({
        category: 'upcoming',
        reservation_status: 'booked',
        sales_status_exclude: 'cancel',
        safari_group: true,
        page: this.pagination_booked.page,
        page_size: 20,
      })
        .then(res => {
          this.booked_reservations = res.data.results
          this.pagination_booked.pages = res.data.pages
          this.pagination_booked.count = res.data.count
          this.is_page_loaded = true
        })
    },
    onClickBookedPagination(page) {
      this.pagination_booked.page = page
      this.fetchBookedReservations()
    },
  }
}
</script>
